import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@saucelabs/ds-button';
import { Link } from 'react-router-dom';

import { Actions, Heading } from './PopoverComponents';

const CREDIT_STARTER_PRICE = '$50.00';

const FreemiumEmptyCreditsPopover = ({ onClose, daysToRefill }) => (
  <div
    className="w-50 max-w-screen bg-white border border-gray-200 border-solid shadow-md rounded p-3 absolute right-0 top-full mt-0.5"
    style={{
      width: 528,
    }}
  >
    <Heading onClose={onClose}>
      {'You are out of credits'}
    </Heading>
    <div>
      {`Your free credits have run out and will be refilled in ${daysToRefill} days. `}
      {'To get more credits now, upgrade to a paid plan.'}
    </div>
    <Actions>
      <Button
        className="text-center justify-center px-3"
        color="primary"
        component={Link}
        size="sm"
        to="/billing"
      >
        <span className="font-normal">
          {`Find a plan (starting at ${CREDIT_STARTER_PRICE} per month)`}
        </span>
      </Button>
    </Actions>
  </div>
);

FreemiumEmptyCreditsPopover.propTypes = {
  daysToRefill: PropTypes.number,
  onClose: PropTypes.func,
};

FreemiumEmptyCreditsPopover.defaultProps = {
  daysToRefill: 0,
  onClose: () => {},
};

export default FreemiumEmptyCreditsPopover;
export { FreemiumEmptyCreditsPopover };
